<template>
  <v-navigation-drawer v-model="drawer" app dark temporary>
    <v-list>
      <v-list-tile 
        v-for="(link, i) in links" :key="i"
        :to="link.to"
        :href="link.href"
        @click="onClick($event, link)" >

        <v-list-tile-title class="menu-btn" v-text="link.text" />
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'Drawer',
  props:['drawer'],
    data () {
    return {
      links: [
        {icon: 'done', text: 'Номе', href: '/'},
        {icon: 'done', text: 'Gallery', href: '/gallery'},  
        {icon: 'done', text: 'Contact', href: '/contacts'}, 
        {icon: 'done', text: 'Art Lessons', href: '/lessons'},
        {icon: 'done', text: 'Portrait Demos', href: '/portraits'},  
        {icon: 'done', text: 'About Maria', href: '/contacts'},
        {icon: 'done', text: 'Login', href: '/login'}                                                
      ]
    }
  },
}
</script>